<script setup>
import {modalDialog} from "./index.js"

const store = modalDialog();
/* const inputStyleClass = computed(() => {
    get: () => {}
    set: () => {}
}) */

function getStyleClassLabel(input) {
    if(input.error === true) {
        return "text-danger"
    }
/*     if(input.type == "select" && input.placeholder != "" && input.value === input.placeholder) {
        return "text-grey"
    } */
    return ""
}

function getStyleClassInput(input) {
    if(input.error === true) {
        return "bg-danger-light border-danger"
    }
/*     if(input.type == "select" && input.placeholder != "" && input.value === input.placeholder) {
        return "text-grey"
    } */
    return ""
}

/**
 * 
 * @param {Dialog} dialog 
 */
function cancelIsPressed(dialog) {
    dialog.close()
    dialog.cancel();
}

function confirmIsPressed(btn) {

    let possibleToRun = true;
    if(btn.parentDialog.isSomeButtonLoading()) {
        possibleToRun = false 
    }
    for(let input of btn.parentDialog.inputFields) {
        if(input.mandatory == true && (input.value == "" || input.value == undefined || input.value == null )) {
            input.setError()
            possibleToRun = false
        } else {
            input.setError(false)
        }
    }
    if(possibleToRun === true) {
        btn.setLoading(true)
        btn.run()
    }
}

function inputChanged(input) {
    input.setError(false)
}

</script>

<template>
    <div class="background m-0 p-0"  v-if="store.dialogItems.length>0">

        <template v-for="item of store.dialogItems" :key="item.id">
        <div class="card-container">
            <div class="beg-card bg-white">
                <div class="beg-card-header" v-if="item.topic">
                    {{ item.topic }}
                </div>
                <div class="beg-card-body" v-html="item.message">
                </div>
                <div class="beg-card-form" v-if="item.inputFields.length>0">
                <div class="neulandInputs form">
                    <template v-for="element of item.inputFields" :key="element.id">
                        <label :class="getStyleClassLabel(element)" v-if="element.labelText">{{ element.labelText }}</label>
                        <input v-if="element.type=='text'" class="mb-2" type="text" :class="getStyleClassInput(element)" @keyup="inputChanged(element)" v-model="element.value" :placeholder="element.placeholder" />
                        <input v-if="element.type=='number'" class="mb-2" type="number" :class="getStyleClassInput(element)" @keyup="inputChanged(element)" v-model="element.value" :placeholder="element.placeholder" />
                        <template v-if="element.type=='select'" >
                            <select :class="getStyleClassInput(element)" class="mb-2" @change="inputChanged(element)" v-model="element.value" :placeholder="element.placeholder">
                                <option hidden disabled v-if="element.placeholder" class="text-grey" :value="element.placeholder">{{ element.placeholder }}</option>
                                <option v-for="option of element.options" :key="option.id">{{ option.name }}</option>
                            </select>
                        </template>
                    
                    </template>
                </div>
                </div>
                <div class="beg-card-footer">
                    <button v-if="item.cancelBtnShow" @click="cancelIsPressed(item)" class="btn btn-outline-secondary">{{ item.cancelCaption }}</button>
                    <template v-for="button of item.buttons" :key="button.id">
                        <button @click="confirmIsPressed(button)" class="btn ms-2" :class="'btn-'+button.styleClass"><span v-if="button.isLoading"><i class="fa-solid fa-spinner fa-spin"></i></span> {{ button.caption }}</button>
                    </template>
                </div>
            </div>
        </div>
        </template>

</div>
</template>

<style scoped>
.background {
    position: fixed;
    width: 100%;
    background-color: rgba(0,0,0,0.5);
    height: 100%;
    top: 0;
    left: 0;
    z-index: 200;
}

.card-container {
    max-width: 620px;
    margin: auto;
    margin-top: 50px;
}

.neulandInputs{
    max-width: 1000px;
}
</style>